export { default } from './CGMTab';
